export default __webpack_public_path__ + "static/media/39k.fed8a2b6.md";